import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-fi_x',
  standalone: true,
  templateUrl: '../../assets/fi_x.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamFi_xIcon {}
